export default __webpack_public_path__ + "static/media/education_img.70cc97cc.png";